export default "__VITE_ASSET__DDUQ$umS__"